import { reactive } from "vue";
export const caboHover = reactive({ cabo: null, origem: null });
